<template>
  <div id="printQrCodes" style="width: 210mm; height: 297mm">
    <div
      style="
        display: grid;
        grid-template-columns: repeat(2, 2fr);
        justify-content: space-between;
      "
    >
      <div
        v-for="(card, i) in data"
        :key="i"
        :style="
          `position: relative; margin-bottom: 4mm; ${
            i % 4 === 0 ? 'page-break-before: always;' : ''
          }`
        "
      >
        <p class="card-subtitle">{{ card.prefecture_social_name }}</p>
        <p class="card-subtitle">{{ card.sec_name }}</p>
        <p class="card-subtitle">Veículo: {{ card.model_desc }}</p>
        <p class="card-subtitle">Placa: {{ card.vehicle_board }}</p>
        <p class="card-subtitle">Senha: {{ card.vehicle_password }}</p>
        <img
          src="@/assets/card.png"
          style="width: 102.9mm; height: 70.4mm; text-align: left"
        />
        <img
          v-if="card.prefecture_logo"
          :src="'https://api.sigfrotagov.com.br/uploads/' + card.prefecture_logo"
          style="
            width: 25mm;
            height: 25mm;
            position: absolute;
            top: 110px;
            left: 275px;
          "
        />
        <div
          style="
            width: 40mm;
            height: 16mm;
            position: absolute;
            bottom: 28mm;
            left: 80px;
          "
        >
          <img
            :src="
              `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${card.vehicle_password}`
            "
            alt=""
            :title="card.vehicle_password"
            width="100"
            height="100"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
};
</script>
